module.exports = __webpack_public_path__ + "static/img/dialog-bg.bf085e2b.png";